import { Building, BarChart3, ListChecks, Code2, Puzzle, ShieldCheck, MessageSquare, type LucideIcon } from 'lucide-react';

export interface SubMenuItem {
	label: string;
	path: string;
}

export interface MenuItem {
	label: string;
	path: string;
	icon: LucideIcon;
	subItems?: SubMenuItem[];
	activePrefix?: string;
}

export const superAdminMenuItems: MenuItem[] = [
	{
		label: 'Accounts',
		path: '/super-admin/accounts',
		icon: Building
	},
	{
		label: 'Analytics',
		path: '/super-admin/analytics',
		icon: BarChart3
	},
	{
		label: 'CS Intents',
		path: '/super-admin/cs-intents',
		icon: ListChecks
	},
	{
		label: 'Developers',
		path: '/super-admin/developers/tool-clients',
		icon: Code2,
		activePrefix: '/super-admin/developers',
		subItems: [{ label: 'Tool Server Clients', path: '/super-admin/developers/tool-clients' }]
	},
	{
		label: 'Extension',
		path: '/super-admin/extension-versions',
		icon: Puzzle
	},
	{
		label: 'Role Permissions',
		path: '/super-admin/role-permissions',
		icon: ShieldCheck
	},
	{
		label: 'Feedbacks',
		path: '/super-admin/feedbacks',
		icon: MessageSquare
	}
];
